import BaseComponent from "@/components/Empties/BaseComponent";
import PartnerSuspenseRouteHandler from "@/components/SuspenseRouteHandler/PartnerSuspenseHandler";
import NotFound from "@/Pages/NotFound";
import PartnerLoginPage from "@/PartnerPages/Login";
import { getRedirectPathFromAuth } from "@/utility/auth.utils";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { redirect, RouteObject } from "react-router-dom";
import App from "../Pages/App";
import PartnerProtectedRoute from "./PartnerProtectedRoute";
import { PARTNERS_TABS } from "./partnerSidebar.utility";

const partnerRoutes: RouteObject[] = [
  {
    index: true,
    element: <BaseComponent />,
  },
  {
    path: "login",
    loader: async () => {
      try {
        const path = await getRedirectPathFromAuth();
        return redirect(path);
      } catch (error) {
        return null;
      }
    },
    element: <PartnerLoginPage />,
  },
  ...PARTNERS_TABS.map((tab): RouteObject => {
    const hasSubTabs = tab.subTabs && tab.subTabs.length > 0;
    return {
      path: `${stringUtility.removeSpaceAddChar(tab.name, "-")}${
        hasSubTabs ? "/:subTab/*" : "/*"
      }`,
      element: (
        <PartnerProtectedRoute>
          <PartnerSuspenseRouteHandler route={tab.name} />
        </PartnerProtectedRoute>
      ),
    };
  }),
  {
    path: "test-route",
    element: <App />,
  },
  { path: "*", element: <NotFound /> },
];

export default partnerRoutes;
